import NavBar from "../../../layout/navBar/NavBar";
import SideBar from "../../../layout/sideBar/SideBar";
import { makeStyles } from "@material-ui/core/styles";
import MasiveLinksArticle from "../masivesLinks/MasiveLinksArticle";
import useValidateJwt from "../../../hooks/useValidateJwt";

const CreateMassiveLinks = () => {
  const mouseDownHandler = useValidateJwt();
  const styles = makeStyles((theme) => ({
    offset: theme.mixins.toolbar,
    content: {
      padding: theme.spacing(3),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
    },
  }));

  const style10 = styles();

  return (
    <div onMouseDown={mouseDownHandler} style={{ display: "flex" }}>
      <NavBar route={"Crear links masivos"} />
      <SideBar />
      <div className={style10.content}>
        <div className={style10.offset}></div>

        <div
          style={{
            width: "100%",
            height: "80vh",
            position: "relative",
            top: "40px",
          }}
        >
          <MasiveLinksArticle />
        </div>
      </div>
    </div>
  );
};

export default CreateMassiveLinks;
